<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/global-bg.png" />
    <div>
      <div class="list no-padding">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">公司整体目标分解到产品</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart05M id="global06" :datas="data01" :colors="colors" :radius="radius" height="340px"/>
      </div>
      <div class="list no-padding">
        <div class="selectP">
          
        </div>
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title"><el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>产品季度分析</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart05M id="global07" :datas="data02" :colors="colors" height="240px"/>
      </div>
      <div class="list">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">{{selctLabel}}产品月度分析</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart07M01 id="global08" :datas="data03" :items="items" :dimensions="dimensions" height="460px" />
      </div>
    </div>
    <NavStyle :navIndex="2"></NavStyle>
  </div>
</template>

<script>
  import Echart05M from '../../components/Echart05M.vue'
  import Echart07M01 from '../../components/Echart07M01.vue'
  import NavStyle from '../../components/NavStyle.vue'
  
  export default {
    name: 'GlobalY',
    components: {
      Echart05M,
      Echart07M01,
      NavStyle
    },
    data() {
      return {
        loading: false,
        value: 0,
        options: [
          { value: 0, label: '配电终端类' },
          { value: 1, label: '低压终端类' },
          { value: 2, label: '断路器/成套类' },
          { value: 3, label: '环网柜/成套类' },
          { value: 4, label: '机器人/辅控类' },
          { value: 5, label: '新能源类' },
          { value: 6, label: '智能制造类' },
          { value: 7, label: '检测平台类' },
          { value: 8, label: '运维类' },
          { value: 9, label: '其他类' },
        ],
        colors: [ '#2dfcff','#ffda2d','#be2dfa','#ff8b07','#c2ff34','#00aaff','#ffaaff','#ff0004','#55ff00','#ffffff',],
        radius: ['30%', '45%'],
        data: [],
        // data01: [
        //   { value: 33450, name: '配电终端类' },
        //   { value: 14850, name: '低压终端类' },
        //   { value: 42600, name: '断路器/成套类' },
        //   { value: 36180, name: '环网柜/成套类' },
        //   { value: 7900, name: '机器人/辅控类' },
        //   { value: 19790, name: '新能源类' },
        //   { value: 7450, name: '智能制造类' },
        //   { value: 5900, name: '检测平台类' },
        //   { value: 10400, name: '运维类' },
        //   { value: 25580, name: '其他类' },
        // ],
        // data02: [
        //   { value: 22934, name: '第一季度' },
        //   { value: 60862, name: '第二季度' },
        //   { value: 58416, name: '第三季度' },
        //   { value: 62081, name: '第四季度' }
        // ],
        items: ['月度目标', '月度占比'],
        dimensions: ['name', 'value1', 'value2'],
        // data03: [
        //   {name: "1月", value1: 6075, value2: 3}, 
        //   {name: "2月", value1: 5107, value2: 2}, 
        //   {name: "3月", value1: 11752, value2: 6}, 
        //   {name: "4月", value1: 18701, value2: 9}, 
        //   {name: "5月", value1: 19573, value2: 10}, 
        //   {name: "6月", value1: 22588, value2: 11}, 
        //   {name: "7月", value1: 18371, value2: 9}, 
        //   {name: "8月", value1: 19640, value2: 10}, 
        //   {name: "9月", value1: 20405, value2: 10}, 
        //   {name: "10月", value1: 20858, value2: 10}, 
        //   {name: "11月", value1: 21811, value2: 11}, 
        //   {name: "12月", value1: 19412, value2: 10}, 
        // ].reverse()
      }
    },
    mounted() {
      this.$axios.post('/product_goal/findList').then( res => {
        this.data = res.data.data
      })
    },
    computed: {
      selctLabel() {
        return this.options.filter(item => item.value === this.value)[0].label
      },
      data01() {
        let arr = []
        this.data.map(item => {
          arr.push({name: item.productName, value: item.sum,})
        })
        return arr
      },
      data02() {
        let obj = this.data[this.value] || [{},{},{},{}]
        return [
          { value: obj.q1th, name: '第一季度' },
          { value: obj.q2th, name: '第二季度' },
          { value: obj.q3th, name: '第三季度' },
          { value: obj.q4th, name: '第四季度' },
        ]
      },
      data03() {
        let obj = this.data[this.value] || []
        let arr = []
        for(let i = 1 ; i < 13; i++) {
          arr.push(
            {name: i + '月', value1: obj['demo' + i]*1, value2:  (obj['demo' + i]/obj.sum*100).toFixed(0)}
          )
        }
        return arr.reverse()
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
    display: flex;
    line-height: 30px;
  }

  .list {
    padding-bottom: 40px;
  }
  
  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }
  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }
  
  .icon-cur{
    color: white;
    background-color: #1fd6d9;
  }
  
  .title-cont01 {
    margin-bottom: 20px
  }
  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .echart-box > div {
    width: 50%;
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
  .no-padding {
    padding: 0 !important;
  }
  
  .selectP {
    padding: 0 0 10px 10px;
    display: flex;
    justify-content: center;
  }
  
  .el-select,.el-input {

    background-color: transparent;
  }
  .el-select >>> .el-input__inner {
    width: 8em;
    height: 30px;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
    color: #2dfcff;
    background-color: rgba(45, 252, 255, .1);
    border: 1px solid rgba(45, 252, 255, .2);
    padding: 0 6px;
    margin-right: 6px;
  }
  
  .el-select >>> .el-input__icon {
    color: #2dfcff;
    line-height: 30px;
  }
</style>
